import { render } from "./AndroidIcon.vue?vue&type=template&id=1680fab0&ts=true"
import script from "./AndroidIcon.vue?vue&type=script&lang=ts"
export * from "./AndroidIcon.vue?vue&type=script&lang=ts"

import "./AndroidIcon.vue?vue&type=style&index=0&id=1680fab0&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__